import { useEffect } from "react"
import { get } from '@util/xhrAPI'
import { useSelector, useDispatch } from 'react-redux'
import { fullUpdate, updateDisplayedSeason } from '@store/slice/dashboardSlice'
import { useTranslation } from 'react-i18next'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import SeasonDashboard from '@scene/window/dashboard/__partials/SeasonDashboard'
import GlobalVueDashboard from '@scene/window/dashboard/__partials/GlobalVueDashboard'

const Dashboard = () => {
  const { mission } = useSelector(state => state.main)
  const { data, displayedSeason } = useSelector(state => state.dashboard)
  const { missionSeasons, activeSeason } = mission
  const [t] = useTranslation('common')
  const dispatch = useDispatch()
  const globalVueTag = 'globalVue'
  const seasonsNames = Object.values(missionSeasons) || []

  const updateSeason = season => {
    if (season !== displayedSeason) {
      dispatch(updateDisplayedSeason(season))
    }
  }

  const getSeasons = () => {
    const seasonsButtons = seasonsNames.map(season => {
      return {
        cssClass: `is-rounded ${displayedSeason == season ? 'is-active is-success' : ''}`,
        callback: () => updateSeason(season),
        text: 'current_season' === season ? t('actions.current_season') : season
      }
    })
    seasonsButtons.push({
      cssClass: `is-rounded ${globalVueTag === displayedSeason ? 'is-active is-success' : ''}`,
      callback: () => updateSeason(globalVueTag),
      text: t('actions.global_vue')
    })
    return <Buttons buttons={seasonsButtons} />
  }

  useEffect(() => {
    if (null === data) {
      get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/dashboard`, response => {
        const { errors, data } = response
        dispatch(fullUpdate({ errors, data }))
      })
    }
    if (null === displayedSeason) {
      dispatch(updateDisplayedSeason(activeSeason.name))
    }
  }, [])

  return (
    <>
      {
        null !== data
          ?
          <Div cssClass='dashboard'>
            <Div cssClass='seasons'>
              <h3>{t('titles.seasons')}</h3>
              {getSeasons()}
            </Div>
            {displayedSeason === globalVueTag ? <GlobalVueDashboard /> : <SeasonDashboard />}
          </Div>
          : <></>
      }
    </>
  )
}

export default Dashboard